import { EachQuestionContainer } from '../QuizPageStyles.styles';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Answer from './Answer.component';

// Displays each question for the quiz
const EachQuestion = ({
  q,
  i,
  setCorrect,
  correct,
  setAnswered,
  setAnsweredQuestions,
  answeredQuestions,
  setUserAnswers,
  userAnswers,
}) => {
  const {
    id,
    question,
    correctAnswer,
    answer1,
    answer2,
    answer3,
    answer4,
    answer5,
    answer6,
    answer7,
    answer8,
  } = q;
  const [selected, setSelected] = useState();

  const checkAnswer = (e) => {
    const ans = e.target.value;
    if (ans === correctAnswer) {
      setCorrect(correct + 1);
    }
    setSelected(ans);
    setUserAnswers((prev) => ({
      ...prev,
      [id]: ans,
    }));
  };
  useEffect(() => {
    if (selected && !answeredQuestions[id]) {
      setAnswered((prev) => prev + 1);
      setAnsweredQuestions((prev) => ({
        ...prev,
        [id]: true,
      }));
    }
  }, [selected, id, answeredQuestions, setAnswered, setAnsweredQuestions]);

  useEffect(() => {
    if (Object.keys(userAnswers).length > 0) {
      localStorage.setItem(`quizAnswers-${id}`, JSON.stringify(userAnswers));
    }
  }, [userAnswers, id]);

  useEffect(() => {
    // Check if there is a saved answer for this question
    if (userAnswers[id]) {
      setSelected(userAnswers[id]); // Restore the saved answer
    }
  }, [userAnswers, id]);

  return (
    <EachQuestionContainer>
      <div key={id} id={id}>
        <div className="questionContainer">
          <p>{i + 1}.</p>
          <p className="question">{question}</p>
        </div>
        {answer1 && (
          <Answer
            selected={selected}
            answer={answer1}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer2 && (
          <Answer
            selected={selected}
            answer={answer2}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer3 && (
          <Answer
            selected={selected}
            answer={answer3}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer4 && (
          <Answer
            selected={selected}
            answer={answer4}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer5 && (
          <Answer
            selected={selected}
            answer={answer5}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer6 && (
          <Answer
            selected={selected}
            answer={answer6}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer7 && (
          <Answer
            selected={selected}
            answer={answer7}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
        {answer8 && (
          <Answer
            selected={selected}
            answer={answer8}
            id={id}
            checkAnswer={checkAnswer}
          />
        )}
      </div>
    </EachQuestionContainer>
  );
};
EachQuestion.propTypes = {
  q: PropTypes.shape({
    id: PropTypes.number,
    question: PropTypes.string,
    correctAnswer: PropTypes.string,
    answer1: PropTypes.string,
    answer2: PropTypes.string,
    answer3: PropTypes.string,
    answer4: PropTypes.string,
    answer5: PropTypes.string,
    answer6: PropTypes.string,
    answer7: PropTypes.string,
    answer8: PropTypes.string,
  }),
  i: PropTypes.number,
  setCorrect: PropTypes.func,
  correct: PropTypes.number,
  setAnswered: PropTypes.func,
  setAnsweredQuestions: PropTypes.func,
  answeredQuestions: PropTypes.object,
  setUserAnswers: PropTypes.func,
  userAnswers: PropTypes.object,
};

export default EachQuestion;
